import {apiClient} from 'common/util/api-client';
import {getAlertDetailUrl, getAlertUrl} from './common';

function _fetchUrl(alert, projectId) {
  const {anomaly, contour} = alert;

  let detailId = null;
  if (anomaly && anomaly.anomalyDetail) {
    detailId = anomaly.anomalyDetail.anomalyDetailId;
  } else if (contour && contour.contourDetail) {
    detailId = contour.contourDetail.contourDetailId;
  }

  if (detailId) {
    return getAlertDetailUrl({projectId, alertId: alert.alertId, detailId});
  } else {
    return getAlertUrl({projectId, alertId: alert.alertId, detailId});
  }
}

export function fetchAlert(alert, projectId, method, params, api = apiClient) {
  return api
    .fetch(_fetchUrl(alert, projectId), {method, body: JSON.stringify(params)})
    .then((response) => response.json());
}
